import React, { FC } from 'react';
import styled from 'styled-components';
import { Text } from 'components/text/Text';
import { SubSectionHeadlineWrapper } from '../../pages-all/home/components/parts/default.parts';
import { TITLE_LINE_HEIGHT, bodyFontSize } from '../../pages-all/home/home.page.const';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { colors } from 'styles/colors';
import { Typography } from 'antd';

const DescriptionContainer = styled.div`
  display: block;
  flex-basis: 100%;
  padding: 12px;
`;

const getColor = (i: number, reverseColor?: boolean, monoColor?: boolean) => {
  if (monoColor) return colors.black;
  if (reverseColor) return i === 0 ? colors.primary : colors.black;
  return i === 1 ? colors.primary : colors.black;
};

const InfoBox = styled.div<{ mobile?: boolean }>`
  border-radius: 30px;
  padding: 4px 8px;
  width: ${({ mobile }) => (mobile ? '' : 'max-content')};
  margin: 30px 0 0 0;
  background-color: ${colors.blueWhite};
`;

export const DescriptionTile: FC<{
  minTablet: boolean;
  maxMobileLarge: boolean;
  minDesktop: boolean;
  minWideDesktop: boolean;
  description: string | JSX.Element | JSX.Element[];
  heading: string;
  imageSource?: string;
  reverseColor?: boolean;
  monoColor?: boolean;
  hint?: boolean;
}> = ({
  minTablet,
  maxMobileLarge,
  minDesktop,
  minWideDesktop,
  description,
  heading,
  imageSource,
  reverseColor,
  monoColor,
  hint,
  children,
}) => {
  const { Title } = Typography;

  return (
    <DescriptionContainer>
      <SubSectionHeadlineWrapper
        tablet={minTablet}
        mobile={maxMobileLarge}
        desktop={minDesktop}
        style={{ margin: minWideDesktop ? '30px auto auto auto' : '40px auto 40px auto' }}
      >
        {imageSource && (
          <div style={{ paddingBottom: '8px' }}>
            <img src={imageSource} alt="tile" width="60px" loading="lazy" />
          </div>
        )}
        <Title
          level={3}
          style={{
            fontSize: minTablet ? 30 : 26,
            fontWeight: 700,
            display: 'block',
            textAlign: !minTablet ? 'center' : 'left',
            lineHeight: TITLE_LINE_HEIGHT,
          }}
        >
          {heading.split('\n').map((line, i, array) => (
            <span key={i} style={{ color: getColor(i, reverseColor, monoColor) }}>
              {line}
              {i !== array.length - 1 && <br />}
            </span>
          ))}
        </Title>
        {hint && (
          <InfoBox mobile={!minTablet}>
            <Text size={13} color={'black'} fontWeight={600}>
              {translate(translationKeys.homepage.donationPromotion.infoBoxBadge)}
            </Text>
          </InfoBox>
        )}
        <div style={{ margin: '40px 0 0 0' }}>
          {typeof description === 'string' ? (
            description.split('\n').map((line, i) => (
              <Text
                key={i}
                size={bodyFontSize(maxMobileLarge)}
                style={{ display: 'block', marginBottom: '30px' }}
              >
                {line}
              </Text>
            ))
          ) : (
            <Text
              size={bodyFontSize(maxMobileLarge)}
              style={{ display: 'block', marginBottom: '30px' }}
            >
              {description}
            </Text>
          )}
        </div>
        {children}
      </SubSectionHeadlineWrapper>
    </DescriptionContainer>
  );
};
